export const LIST_RESULT_CONCLUSION_LIBRARY_REQUEST = 'LIST_RESULT_CONCLUSION_LIBRARY_REQUEST'
export const LIST_RESULT_CONCLUSION_LIBRARY_SUCCESS = 'LIST_RESULT_CONCLUSION_LIBRARY_SUCCESS'
export const LIST_RESULT_CONCLUSION_LIBRARY_FAIL = 'LIST_RESULT_CONCLUSION_LIBRARY_FAIL'

export const LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_REQUEST = 'LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_REQUEST'
export const LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_SUCCESS = 'LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_SUCCESS'
export const LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_FAIL = 'LIST_RESULT_CONCLUSION_LIBRARY_SUMMARY_FAIL'

export const CREATE_RESULT_CONCLUSION_LIBRARY_REQUEST = 'CREATE_RESULT_CONCLUSION_LIBRARY_REQUEST'
export const CREATE_RESULT_CONCLUSION_LIBRARY_SUCCESS = 'CREATE_RESULT_CONCLUSION_LIBRARY_SUCCESS'
export const CREATE_RESULT_CONCLUSION_LIBRARY_FAIL = 'CREATE_RESULT_CONCLUSION_LIBRARY_FAIL'

export const DETAIL_RESULT_CONCLUSION_LIBRARY_REQUEST = 'DETAIL_RESULT_CONCLUSION_LIBRARY_REQUEST'
export const DETAIL_RESULT_CONCLUSION_LIBRARY_SUCCESS = 'DETAIL_RESULT_CONCLUSION_LIBRARY_SUCCESS'
export const DETAIL_RESULT_CONCLUSION_LIBRARY_FAIL = 'DETAIL_RESULT_CONCLUSION_LIBRARY_FAIL'

export const UPDATE_RESULT_CONCLUSION_LIBRARY_REQUEST = 'UPDATE_RESULT_CONCLUSION_LIBRARY_REQUEST'
export const UPDATE_RESULT_CONCLUSION_LIBRARY_SUCCESS = 'UPDATE_RESULT_CONCLUSION_LIBRARY_SUCCESS'
export const UPDATE_RESULT_CONCLUSION_LIBRARY_FAIL = 'UPDATE_RESULT_CONCLUSION_LIBRARY_FAIL'

export const DELETE_RESULT_CONCLUSION_LIBRARY_REQUEST = 'DELETE_RESULT_CONCLUSION_LIBRARY_REQUEST'
export const DELETE_RESULT_CONCLUSION_LIBRARY_SUCCESS = 'DELETE_RESULT_CONCLUSION_LIBRARY_SUCCESS'
export const DELETE_RESULT_CONCLUSION_LIBRARY_FAIL = 'DELETE_RESULT_CONCLUSION_LIBRARY_FAIL'
